export default __webpack_public_path__ + "static/media/txr-retina-log.fd1770a0.svg";